import Vue from "vue";
import App from "./App.vue";
import ElementUI from 'element-ui';
import('./assets/scss/app.scss');
import commonComponents from './components/global';
import http from './config/http';

Vue.config.productionTip = false;

Vue.prototype.$http = http;
//本地打包element的样式
if(process.env.NODE_ENV !== 'production') {
  import("element-ui/lib/theme-chalk/index.css");
};
Vue.use(ElementUI);
Vue.use(commonComponents);

new Vue({
  render: h => h(App)
}).$mount("#app");
